const isCapacity = value => value !== null && value !== undefined && value !== '' && Number.isInteger(Number(value)) && Number(value) >= 0

export const hasVehicleCapacities = option => isCapacity(option.maximumPassengers) && isCapacity(option.minimumBags)

export const mergeVehicleCapacities = (options, details) => {
  const byID = new Map(details.map(item => [Number(item.id ?? item.ID), item]))
  return options.map(option => {
    const detail = byID.get(Number(option.value))
    if (!detail) return option
    const passengers = detail.maximumPassengers ?? detail.MaximumPassengers
    const bags = detail.minimumBags ?? detail.MinimumBags
    return {
      ...option,
      maximumPassengers: isCapacity(option.maximumPassengers) ? option.maximumPassengers : passengers,
      minimumBags: isCapacity(option.minimumBags) ? option.minimumBags : bags
    }
  })
}
